import {
  ChangeDetectorRef,
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  NgZone,
  OnChanges,
} from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';

import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Settings } from '../settings/settings';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Registry } from '../registry/registry';
import { CartItem } from '../cart/cartItem';
import { Cart } from '../cart/cart';
import { GiftSelection } from '../gift/giftSelection';
import { GuestWish } from '../gift-wish/wish';
import { RegistryService } from '../registry/registry.service';
import { PayEngineService } from '../services/payengine.service';
@Component({
  selector: 'app-gift-creditcard',
  templateUrl: './gift-creditcard.component.html',
  styleUrls: ['./gift-creditcard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GiftCreditCardComponent implements OnInit, OnChanges {
  @Input() amount: number;
  @Input() guestFee: number;
  @Input() merchantId: string = "";
  @Input() isCart: boolean = false;
  @Input() cart: Cart;
  @Input() giftSelection: GiftSelection;
  @Input() price: number;
  @Input() wish: GuestWish
  @Input() numOfCustomPaymentMethods: number = 0;
  @Input() grandTotal: number;
  @Input() previewMode: boolean = false;
  form: any;
  settings: Settings;
  registry: Registry;
  showPaymentForm: boolean = false;
  payEngine: any;
  credtCardCountry: string = '';
  results: string = '';
  private startTime: number = 0;
  config = environment.payengine;

  // Address lookup related properties - Countries that support Visa and Mastercard processing
  countries = [
    { code: 'ad', name: 'Andorra' },
    { code: 'ae', name: 'United Arab Emirates' },
    { code: 'ar', name: 'Argentina' },
    { code: 'at', name: 'Austria' },
    { code: 'au', name: 'Australia' },
    { code: 'bb', name: 'Barbados' },
    { code: 'be', name: 'Belgium' },
    { code: 'bg', name: 'Bulgaria' },
    { code: 'bh', name: 'Bahrain' },
    { code: 'bm', name: 'Bermuda' },
    { code: 'br', name: 'Brazil' },
    { code: 'bs', name: 'Bahamas' },
    { code: 'ca', name: 'Canada' },
    { code: 'ch', name: 'Switzerland' },
    { code: 'cl', name: 'Chile' },
    { code: 'cn', name: 'China' },
    { code: 'co', name: 'Colombia' },
    { code: 'cr', name: 'Costa Rica' },
    { code: 'cy', name: 'Cyprus' },
    { code: 'cz', name: 'Czech Republic' },
    { code: 'de', name: 'Germany' },
    { code: 'dk', name: 'Denmark' },
    { code: 'do', name: 'Dominican Republic' },
    { code: 'ec', name: 'Ecuador' },
    { code: 'ee', name: 'Estonia' },
    { code: 'eg', name: 'Egypt' },
    { code: 'es', name: 'Spain' },
    { code: 'fi', name: 'Finland' },
    { code: 'fr', name: 'France' },
    { code: 'gb', name: 'United Kingdom' },
    { code: 'gi', name: 'Gibraltar' },
    { code: 'gr', name: 'Greece' },
    { code: 'gt', name: 'Guatemala' },
    { code: 'hk', name: 'Hong Kong' },
    { code: 'hr', name: 'Croatia' },
    { code: 'hu', name: 'Hungary' },
    { code: 'id', name: 'Indonesia' },
    { code: 'ie', name: 'Ireland' },
    { code: 'il', name: 'Israel' },
    { code: 'in', name: 'India' },
    { code: 'is', name: 'Iceland' },
    { code: 'it', name: 'Italy' },
    { code: 'jm', name: 'Jamaica' },
    { code: 'jo', name: 'Jordan' },
    { code: 'jp', name: 'Japan' },
    { code: 'ke', name: 'Kenya' },
    { code: 'kr', name: 'South Korea' },
    { code: 'kw', name: 'Kuwait' },
    { code: 'ky', name: 'Cayman Islands' },
    { code: 'lb', name: 'Lebanon' },
    { code: 'li', name: 'Liechtenstein' },
    { code: 'lk', name: 'Sri Lanka' },
    { code: 'lt', name: 'Lithuania' },
    { code: 'lu', name: 'Luxembourg' },
    { code: 'lv', name: 'Latvia' },
    { code: 'ma', name: 'Morocco' },
    { code: 'mc', name: 'Monaco' },
    { code: 'mt', name: 'Malta' },
    { code: 'mu', name: 'Mauritius' },
    { code: 'mx', name: 'Mexico' },
    { code: 'my', name: 'Malaysia' },
    { code: 'ng', name: 'Nigeria' },
    { code: 'nl', name: 'Netherlands' },
    { code: 'no', name: 'Norway' },
    { code: 'nz', name: 'New Zealand' },
    { code: 'om', name: 'Oman' },
    { code: 'pa', name: 'Panama' },
    { code: 'pe', name: 'Peru' },
    { code: 'ph', name: 'Philippines' },
    { code: 'pk', name: 'Pakistan' },
    { code: 'pl', name: 'Poland' },
    { code: 'pr', name: 'Puerto Rico' },
    { code: 'pt', name: 'Portugal' },
    { code: 'qa', name: 'Qatar' },
    { code: 'ro', name: 'Romania' },
    { code: 'sa', name: 'Saudi Arabia' },
    { code: 'se', name: 'Sweden' },
    { code: 'sg', name: 'Singapore' },
    { code: 'si', name: 'Slovenia' },
    { code: 'sk', name: 'Slovakia' },
    { code: 'th', name: 'Thailand' },
    { code: 'tn', name: 'Tunisia' },
    { code: 'tr', name: 'Turkey' },
    { code: 'tt', name: 'Trinidad and Tobago' },
    { code: 'tw', name: 'Taiwan' },
    { code: 'ua', name: 'Ukraine' },
    { code: 'us', name: 'United States' },
    { code: 'uy', name: 'Uruguay' },
    { code: 've', name: 'Venezuela' },
    { code: 'vn', name: 'Vietnam' },
    { code: 'za', name: 'South Africa' }
  ];
  selectedCountry: string = '';
  addressQuery: string = '';
  addressResults: any[] = [];
  selectedAddress: any = null;
  private addressQueryChanged = new Subject<string>();
  manualAddressMode: boolean = false;
  addressSelected: boolean = false;
  addressSearchLoading: boolean = false;
  payengineSessionId: string = '';
  formGroup = new FormGroup({
    amount: new FormControl(''),
  });

  isLoading = false;
  error: string | null = null;
  processingPayment: boolean;
  success: boolean;

  minAmount: number = 0;
  minAmountError: string | null = null;

  private transactionPollingInterval: any;
  private readonly POLLING_INTERVAL = 2000; // 2 seconds
  private readonly MAX_POLLING_ATTEMPTS = 30; // 1 minute total
  private pollingAttempts = 0;

  // Non-refundable agreement checkbox
  nonRefundableAgreement: boolean = false;

  // Additional properties used in template
  showTranslation: boolean = false;
  currency: string = 'USD';
  anonymousMode: boolean = false;


  constructor(
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    private ngZone: NgZone,
    private _settingsStateStore: SettingsStateStore,
    private route: ActivatedRoute,
    private _router: Router,
    private registryService: RegistryService,
    private router: Router,
    private payEngineService: PayEngineService
  ) {
  }

  async ngOnInit(): Promise<any> {

    // Get registry from route data using snapshot instead of subscription
    if (this.route.snapshot.data && this.route.snapshot.data.registry) {
      this.registry = this.route.snapshot.data.registry;

      // Set currency from registry
      if (this.registry.currency) {
        this.currency = this.registry.currency;
      }

      // Get settings using registry userId
      if (this.registry && this.registry.userId) {
        this._settingsStateStore.getSettingsViaUserId(this.registry.userId)
          .subscribe(
            settings => {
              this.settings = settings;
            },
            error => {
              console.error('Error fetching settings:', error);
              this.error = 'Failed to load settings';
              this.cd.detectChanges();
            }
          );
      }

    }

    // Get country from localStorage and set it
    const storedCountry = localStorage.getItem('country');
    if (storedCountry) {
      this.selectedCountry = storedCountry.toLowerCase();
    }

    // If in preview mode, set hardcoded merchantId and preset values
    if (this.previewMode) {
      this.merchantId = 'preview-merchant-id-12345';
      this.processingPayment = false;

      // Force PayEngine service reset for preview mode to ensure fresh initialization
      this.payEngineService.reset();

      // Set default country for preview but don't prefill address
      this.selectedCountry = 'us';
      this.nonRefundableAgreement = true;

      this.setMinAmount();
      this.checkMinAmount();
      // Continue with PayEngine initialization for preview mode
    }

    // Only initialize PayEngine if merchantId is provided
    if (!this.merchantId || this.merchantId === '') {
      console.log('⚠️ No merchantId provided, skipping PayEngine initialization');
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.error = null;
    this.startTime = Date.now();

    try {
      // For preview mode, set a hardcoded session ID if none exists
      if (this.previewMode || location.search.includes('preview')) {
        if (!localStorage.getItem('payengineSessionId')) {
          localStorage.setItem('payengineSessionId', 'preview-session-id-' + Date.now());
        }
        this.payengineSessionId = localStorage.getItem('payengineSessionId');
      }

      // Use the PayEngine service - it may already be loaded
      this.payEngine = await this.payEngineService.initializePayEngine();

      if (!this.payengineSessionId) {
        this.payengineSessionId = localStorage.getItem('payengineSessionId');
      }

      if (!this.payengineSessionId) {
        throw new Error('PayEngine session ID not found');
      }


      this.ngZone.runOutsideAngular(() => {
        this.initSecureFieldsOptimized();
      });
    } catch (error) {
      console.error('PayEngine initialization failed:', error);
      this.error = 'Failed to initialize payment system';
      this.isLoading = false;
      this.cd.detectChanges();
      return;
    }
    // Setup address search debounce
    this.addressQueryChanged.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(query => {
      // Only perform search if not in manual mode and address hasn't been selected
      if (query.length >= 3 && this.selectedCountry && !this.manualAddressMode && !this.addressSelected) {
        this.searchAddresses();
      } else {
        this.addressResults = [];
      }
    });

    this.setMinAmount();
    this.checkMinAmount();
  }

  onAddressInput() {
    // Reset address selection state when user starts typing again
    if (this.addressSelected && this.addressQuery !== (this.selectedAddress && this.selectedAddress.full_text)) {
      this.addressSelected = false;
      this.selectedAddress = null;
    }

    // Clear loading state if switching modes or address already selected
    if (this.manualAddressMode || this.addressSelected) {
      this.addressSearchLoading = false;
    }

    // Only trigger search if not in manual mode and not after selecting an address
    if (!this.manualAddressMode && !this.addressSelected) {
      this.addressQueryChanged.next(this.addressQuery);
    }
  }

  searchAddresses() {
    if (this.addressQuery.length < 3 || !this.selectedCountry) {
      return;
    }

    // Set loading state
    this.addressSearchLoading = true;
    this.cd.detectChanges();

    this.http.get(`${environment.firebase.clouldFunctionHost}/getAddressSuggestions?country=${this.selectedCountry}&query=${encodeURIComponent(this.addressQuery)}`)
      .subscribe(
        (results: any) => {
          this.addressResults = results;
          this.addressSearchLoading = false;
          this.cd.detectChanges();
        },
        error => {
          console.error('Error fetching address suggestions:', error);
          this.error = 'Failed to fetch address suggestions';
          this.addressSearchLoading = false;
          this.cd.detectChanges();
        }
      );
  }

  selectAddress(address: any) {
    this.selectedAddress = address;
    this.addressResults = []; // Clear results after selection
    this.addressQuery = address.full_text;
    this.addressSelected = true; // Mark that an address was selected
    this.manualAddressMode = false; // Exit manual mode if it was enabled
    this.cd.detectChanges();

    // Focus on the zipCode input after selecting an address
    setTimeout(() => {
      const zipCodeInput = document.getElementById('zipCode') as HTMLInputElement;
      if (zipCodeInput) {
        zipCodeInput.focus();
        if (!zipCodeInput.value) {
          zipCodeInput.style.border = '1px solid red';
        }
      }
    }, 0);
  }

  enterManualAddressMode() {
    this.manualAddressMode = true;
    this.addressSelected = false;
    this.addressResults = []; // Clear any search results
    this.addressQuery = '';
    this.addressSearchLoading = false; // Clear loading state

    // Create a default empty address structure if none exists
    if (!this.selectedAddress) {
      this.selectedAddress = {
        full_text: '',
        address: {
          address_line1: '',
          address_line2: '',
          address_city: '',
          address_state: '',
          address_zip: ''
        }
      };
    }
    this.cd.detectChanges();
  }

  exitManualAddressMode() {
    this.manualAddressMode = false;
    this.selectedAddress = null;
    this.addressQuery = '';
    this.addressSearchLoading = false; // Clear loading state
    this.cd.detectChanges();
  }

  showForm() {
    this.ngZone.runOutsideAngular(() => {
      this.initSecureFieldsOptimized();
    });
  }

  async initSecureFields() {
    try {
      const css = {
        WebkitAppearance: 'none',
        paddingBottom: '16px',
        WebkitBoxShadow: 'none',
        boxShadow: 'none',
        lineHeight: '24px',
        fontSize: '16px',
        fontWeight: '400',
        color: '#393C3C',
        padding: '0 12px',
        margin: '0px',
        display: 'block',
        height: '48px',
        border: '1px solid #D8D9DA',
        borderRadius: '8px',
        fontFamily: '"Inter Variable","SF Pro Text", "SF Pro Icons", -apple-system, BlinkMacSystemFont, Inter, system-ui, "Segoe UI", Roboto, Helvetica, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        width: 'calc(100% - 27px)',
        WebkitFontSmoothing: 'antialiased',
      };

      this.payEngine.SecureFields.create()
        .then((form: any) => {
          this.form = form;
          const nameId = this.previewMode ? '#preview-card-name' : '#card-name';
          const numberid = this.previewMode ? '#preview-card-number' : '#card-number';
          const expiryId = this.previewMode ? '#preview-card-expiry' : '#card-expiry';
          const cvcId = this.previewMode ? '#preview-card-cvc' : '#card-cvc';

          form.field(nameId, {
            type: 'text',
            name: 'card_holder',
            placeholder: 'Name on card',
            validations: ['required'],
            css,
          });

          form.field(numberid, {
            type: 'card-number',
            name: 'card_number',
            successColor: '#4F8A10',
            errorColor: '#D8000C',
            placeholder: 'Credit Card Number',
            showCardIcon: false,
            validations: ['required', 'validCardNumber'],
            css,
          });
          form.field(expiryId, {
            type: 'card-expiration-date',
            name: 'card_exp',
            successColor: '#4F8A10',
            errorColor: '#D8000C',
            placeholder: 'MM / YY',
            validations: ['required', 'validCardExpirationDate'],
            css,
          });
          form.field(cvcId, {
            type: 'card-security-code',
            name: 'card_cvc',
            successColor: '#4F8A10',
            errorColor: '#D8000C',
            placeholder: 'CVC',
            maxLength: 4,
            validations: ['required', 'validCardSecurityCode'],
            css,
          });

          const secureFieldsInitTime = (Date.now() - this.startTime) / 1000;
          console.log(`SecureFields initialized - ${secureFieldsInitTime.toFixed(2)} seconds`);
        })
        .catch((error: any) => {
          console.log(error);
        });

    } catch (error) {
      this.error = 'Failed to initialize payment form';
      throw error;
    } finally {
      this.isLoading = false;
      this.cd.detectChanges();
    }
  }

  /**
   * Optimized secure fields initialization using pre-created form
   */
  async initSecureFieldsOptimized() {
    try {
      // Check if we have a pre-created secure form from the service
      const preCreatedForm = this.payEngineService.getSecureForm();

      if (preCreatedForm && this.payEngineService.isSecureFormReady()) {
        console.log('Using pre-created secure form');
        this.form = preCreatedForm;

        // Attach fields to DOM elements using service method
        await this.payEngineService.attachSecureFields(this.form);

        const secureFieldsInitTime = (Date.now() - this.startTime) / 1000;
        console.log(`Secure fields attached - ${secureFieldsInitTime.toFixed(2)} seconds (optimized)`);
      } else {
        console.log('Fallback to standard secure fields initialization');
        // Fallback to original method if pre-creation failed
        await this.initSecureFields();
      }
    } catch (error) {
      console.error('Optimized secure fields initialization failed, falling back:', error);
      // Fallback to original method
      await this.initSecureFields();
    } finally {
      this.isLoading = false;
      this.cd.detectChanges();
    }
  }

  async tokenize(event: any) {
    event.preventDefault();
    console.log('tokenizing....');
    try {
      const cardObj = await this.form.createCard({
        manuallyEntered: true,
        address_line1: this.selectedAddress.address.address_line1,
        address_line2: this.selectedAddress.address.address_line2,
        address_city: this.selectedAddress.address.address_city,
        address_state: this.selectedAddress.address.address_state,
        address_zip: this.selectedAddress.address.address_zip,
        address_country: this.selectedAddress.address.address_country,
        email: this.wish.email,
      });

      if (cardObj.card_data.brand == 'amex') {
        //DO NOT SUPPORT AMEX 

      }
      this.updateResult(JSON.stringify(cardObj, null, 4));
    } catch (e) {
      debugger;
      this.processingPayment = false;
      this.updateResult(JSON.stringify(e));
    }
  }


  updateResult(value: string) {
    this.results = value;
    this.cd.detectChanges();
  }

  async tdsPayment(event: any) {
    event.preventDefault();
    this.processingPayment = true;
    this.error = null; // Clear any previous errors

    try {
      const cardObj = await this.form.createCard(
        {
          manuallyEntered: true,
          address_line1: this.selectedAddress.address.address_line1,
          address_line2: this.selectedAddress.address.address_line2,
          address_city: this.selectedAddress.address.address_city,
          address_state: this.selectedAddress.address.address_state,
          address_zip: this.selectedAddress.address.address_zip,
          address_country: this.selectedCountry.toUpperCase(),
          email: this.wish.email,
        }
      );

      const token = cardObj.token;
      this.amount = this.roundToTwoDecimals(this.amount);



      const response: any = await this.http
        .post<any>(`${environment.firebase.clouldFunctionHost}/sale`, {
          browserInfo: await this.payEngine.collectBrowserInfo(),
          merchantID: this.merchantId,
          threeDsEnabled: true,
          fraudMonitorSessionId: this.payengineSessionId,
          amount: this.amount,
          guestFee: this.guestFee,
          token: token,
          giftContributionAmount: this.price,
          guestEmail: this.wish.email,
          guestWishText: this.wish.wishText,
          guestNames: this.wish.fromNames,
          giftId: this.giftSelection.gift.id,
          giftName: this.giftSelection.gift.title,
          registryId: this.registry.id,
          currency: this.registry.currency
        })
        .toPromise();

      if (response.ThreeDSActionRequired) {


        this.payEngine.perform3DSFlow(
          response.ThreeDSData,
          async (res: any) => {

            this.processingPayment = true;
            if (res.success) {
              if (res.status === 'FAIL') {
                this.error = res.responseMessage;
                this.processingPayment = false;

              } else {
                this.startPolling(response.transactionId);
              }
            } else {
              this.error = res.message || 'Payment authentication failed';
              this.processingPayment = false;

            }
          }
        );
      } else {
        // For non-3DS flows, start polling immediately
        this.startPolling(response.transactionId);
      }
    } catch (e) {
      console.error('Payment error:', e);
      this.processingPayment = false;

      // Parse PayEngine validation errors
      this.error = this.parsePayEngineErrors(e);
      this.updateResult(JSON.stringify(e));
    }
  }

  roundToTwoDecimals(num: number): number {
    return Math.round(num * 100) / 100;
  }

  private parsePayEngineErrors(error: any): string {
    try {
      // Check if error is a string containing JSON
      let errorData = error;
      if (typeof error === 'string') {
        try {
          errorData = JSON.parse(error);
        } catch (parseError) {
          return 'Payment failed. Please check your CVV and try again.';
        }
      }

      // Parse field validation errors
      const fieldErrors: string[] = [];

      // Check for card validation errors
      if (errorData.card_cvc && errorData.card_cvc.errorMessages && errorData.card_cvc.errorMessages.length > 0) {
        fieldErrors.push(`CVC: ${errorData.card_cvc.errorMessages[0]}`);
      }

      if (errorData.card_exp && errorData.card_exp.errorMessages && errorData.card_exp.errorMessages.length > 0) {
        fieldErrors.push(`Expiry: ${errorData.card_exp.errorMessages[0]}`);
      }

      if (errorData.card_number && errorData.card_number.errorMessages && errorData.card_number.errorMessages.length > 0) {
        fieldErrors.push(`Card Number: ${errorData.card_number.errorMessages[0]}`);
      }

      if (errorData.card_holder && errorData.card_holder.errorMessages && errorData.card_holder.errorMessages.length > 0) {
        fieldErrors.push(`Cardholder Name: ${errorData.card_holder.errorMessages[0]}`);
      }

      // Return formatted errors or default message
      if (fieldErrors.length > 0) {
        return `Please fix the following: ${fieldErrors.join(', ')}`;
      }

      return 'Payment failed. Please check your CVV and try again.';
    } catch (catchError) {
      return 'Payment failed. Please check your CVV and try again.';
    }
  }


  async initializeForm() {
    this.isLoading = true;
    this.error = null;

    try {
      // ... initialization code
    } catch (error) {
      this.error = 'Failed to initialize payment form';
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  onZipCodeInput(event: any) {
    const zipCodeInput = event.target as HTMLInputElement;
    if (zipCodeInput.value) {
      zipCodeInput.style.border = '';
    }
  }

  setMinAmount() {
    if (!this.registry) {
      return;
    }
    const currency = this.registry.currency || 'USD';
    this.minAmount = this.registryService.getMinAmountForCurrency(currency);
  }

  checkMinAmount() {
    // Use this.price if available, else this.amount
    if (!this.registry) {
      return;
    }
    const value = (typeof this.price !== 'undefined' && this.price !== null) ? this.price : this.amount;
    if (this.registryService.isAmountBelowMinimum(value, this.registry.currency)) {
      this.minAmountError = this.registryService.getMinAmountErrorMessage(this.registry);
    } else {
      this.minAmountError = null;
    }
  }

  shouldHidePreviewForm(): boolean {
    // In preview mode, always show the form to demonstrate functionality
    if (this.previewMode) {
      return false;
    }

    // If not in preview mode, never hide the form
    return false;
  }

  // Call checkMinAmount when price or amount changes
  ngOnChanges() {
    this.setMinAmount();
    this.checkMinAmount();
  }

  private async pollTransactionStatus(transactionId: string): Promise<void> {
    if (this.pollingAttempts >= this.MAX_POLLING_ATTEMPTS) {
      this.stopPolling();
      this.showError('There is an issue with your payment. Please contact support (hello@hitchd.com) with your transaction id: ' + transactionId);
      return;
    }

    try {
      const response = await this.http.get(`${environment.firebase.clouldFunctionHost}/transactions-transactionStatus?id=${transactionId}`).toPromise();
      const data = response as any;

      switch (data.state) {
        case 'COMPLETED':
          this.stopPolling();
          this.success = true;
          this.registryService.setWishSent(true);
          this.registryService.setGiftSelection(null);

          const summary = {
            isManualContribution: false,
            payment: this.price,
            total: this.grandTotal,
            guestFirstName: this.registryService.wish.yourName,
          };

          localStorage.setItem('contrib', JSON.stringify(summary));
          let returnAddress = "/" + this.registry.registryName;
          if (location.href.toLowerCase().includes('/registry/')) {
            returnAddress = "/" + this.registry.registryName + "/registry";
          }
          let urlPath = returnAddress + '/contribution-success';
          if (location.search.includes('preview')) {
            urlPath = urlPath + "?preview=1";
          }

          this._router.navigateByUrl(urlPath);
          break;

        case 'FAILED':
          this.stopPolling();
          this.showError('There is an issue with your payment. Please contact support (hello@hitchd.com) with your transaction id: ' + transactionId + " error:" + data.error || 'Payment failed. Please check your CVV and try again.');
          break;

        case 'PROCESSING':
        case 'CHARGED':
        case 'INITIATED':
          this.pollingAttempts++;
          break;

        default:
          console.warn('Unknown transaction state:', data.state);
          this.pollingAttempts++;
      }
    } catch (error) {
      console.error('Error polling transaction status:', error);
      this.pollingAttempts++;
    }
  }

  private stopPolling(): void {
    if (this.transactionPollingInterval) {
      clearInterval(this.transactionPollingInterval);
      this.transactionPollingInterval = null;
    }
    this.pollingAttempts = 0;
  }

  private startPolling(transactionId: string): void {
    // Stop any existing polling first
    this.stopPolling();

    // Start new polling
    this.pollingAttempts = 0;
    this.transactionPollingInterval = setInterval(() => {
      this.pollTransactionStatus(transactionId);
    }, this.POLLING_INTERVAL);
  }

  private showError(message: string): void {
    this.processingPayment = false;
    this.error = message;
    this.success = false;
    this.cd.detectChanges();
  }

  checkFormValidity(): void {
    // Trigger change detection to update button state
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.stopPolling();
    if (this.addressQueryChanged) {
      this.addressQueryChanged.unsubscribe();
    }

    // Clear loading state on component destruction
    this.addressSearchLoading = false;

    // Clean up PayEngine form if it exists
    if (this.form) {
      try {
        this.form.destroy();
      } catch (error) {
        console.warn('Error destroying PayEngine form:', error);
      }
    }

    // Reset PayEngine service state for fresh initialization
    if (this.previewMode) {
      this.payEngineService.reset();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/gift-creditcard/gift-creditcard.component.ts